import classnames from 'classnames';
import { type FC } from 'react';

import Icon from 'molecules/Icon';
import Socials from 'molecules/Socials';

import styles from 'components/HealthcareEntries/Header/header.module.scss';

import { isNonEmptyArray, titleCase } from 'utils/functions';

import type { IconIds } from 'molecules/Icon';

type LearningHeaderProps = {
  authors: string[] | string | null;
  eyebrow?: string;
  model?: string;
  slug: string | null;
  title: string | null;
};

const LearningHeader: FC<LearningHeaderProps> = ({ authors, model = '', eyebrow, slug, title }) => {
  const modelWithoutTemplateKebab = model?.split('-')?.slice(1).join('');
  const modelTemplateTitledCased = titleCase(model?.split('-')?.slice(1).join(' '));
  const modelNameWithEdgeCase = modelTemplateTitledCased === 'Claims Lesson' ? 'Case Study' : modelTemplateTitledCased;

  return (
    <div className={styles.contentLayoutHeader}>
      <div className={styles.pageHeaderContainer}>
        <div className={styles.spacing || ''}></div>
        <div className={styles.contentContainer}>
          <div className={styles.contentTypeContainer}>
            {modelWithoutTemplateKebab && <Icon icon={modelNameWithEdgeCase.toLowerCase() as IconIds} size={20} />}
            {modelNameWithEdgeCase && <p className={styles.contentTypeTitle}>{modelNameWithEdgeCase}</p>}
            {eyebrow && <p className={styles.contentTypeTitle}>{eyebrow}</p>}
          </div>
          {title && <h1 className={classnames(styles.pageHeaderTitle, 'heading1')}>{title}</h1>}
          {isNonEmptyArray(authors) && (
            <div className={styles.pageHeaderCredentials}>
              {authors && <div className={styles.pageHeaderAuthors}>By: {authors.join(', ')}</div>}
            </div>
          )}
        </div>
      </div>
      {slug && <Socials slug={slug} />}
    </div>
  );
};

export default LearningHeader;
